import { render } from "./TableHeadCell.vue?vue&type=template&id=37f8e71a"
import script from "./TableHeadCell.vue?vue&type=script&lang=js"
export * from "./TableHeadCell.vue?vue&type=script&lang=js"

import "./TableHeadCell.vue?vue&type=style&index=0&id=37f8e71a&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__